module.exports = __webpack_public_path__ + "img/jisao.570f3b88.jpg";